import { DEFAULT_REG_ITEM_IMAGE_PATH } from 'shared/constants'
import { RegItemMinimal } from 'src/types/regItem'

export const shouldDisplayMissingImage = (regItem: RegItemMinimal): boolean =>
  !regItem.imgUrl || regItem.imgUrl === DEFAULT_REG_ITEM_IMAGE_PATH
